/**
 * <admira-before-after> — sections/admira-before-after.liquid.
 *
 * The divider is the range input the element wraps; this only mirrors its
 * value into `--position`, which places the clip, the line and the handle.
 */
class AdmiraBeforeAfter extends HTMLElement {
  connectedCallback() {
    const range = this.querySelector('input[type="range"]');
    if (!(range instanceof HTMLInputElement)) return;

    const update = () => this.style.setProperty('--position', `${range.value}%`);
    range.addEventListener('input', update);
    update();
  }
}

if (!customElements.get('admira-before-after')) {
  customElements.define('admira-before-after', AdmiraBeforeAfter);
}
